/* eslint-disable no-unused-vars */
/* eslint-disable spaced-comment */
import React, { useContext, useEffect } from "react";
import {
  UmbracoContext,
  UmbracoStep,
} from "../../../components/Umbraco/UmbracoContext";
import utils from "../../../utils";
import QuestionFooter from "./QuestionFooter";
import { Label } from 'meitav-uikit';

const { UmbracoUtills } = utils;
import { Parser as HtmlToReactParser } from 'html-to-react';
const htmlToReactParser = new HtmlToReactParser();

export default function Question0(props) {
  const { setNextDisabled } = props;

  const htmlToReactParser = new HtmlToReactParser();
  useEffect(() => {
    setNextDisabled(false);
  }, []);
  const resource = UmbracoStep(
    useContext(UmbracoContext).resource,
    "Question0"
  );
  return (
    <>
      <Label text=
        {htmlToReactParser.parse(
          UmbracoUtills.getValueByKey(resource, "text")
        )}>
      </Label>
      <QuestionFooter
        icon={UmbracoUtills.getValueByKey(resource, "icon")}
        iconUp={UmbracoUtills.getValueByKey(resource, "iconUp")}
        iconDown={UmbracoUtills.getValueByKey(resource, "iconDown")}
        whyImportant={UmbracoUtills.getValueByKey(resource, "whyImportant")}
        tooltip={UmbracoUtills.getValueByKey(resource, "tooltip")}
        stepActive={0}
      />
    </>
  );
}
